const breakpoints = [
  'xs', 'sm', 'md', 'lg', 'xl'
]

const devicesMinWidth = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};

const mobileDevice = {
  width: 600,
  height: 550,
};

const minWidthMediaQuery = (size) => `(min-width: ${size}px)`;
const generateMediaQueries = (prefix = "") => {
  const queries = Object.keys(devicesMinWidth).reduce((acc, key) => {
    return {
      ...acc,
      [key]: `${prefix} ${minWidthMediaQuery(devicesMinWidth[key])}`.trimStart()
    };
  },{});
  return {
    // Why use -0.02: https://getbootstrap.com/docs/5.1/layout/breakpoints/#max-width
    xs: `${prefix} (max-width: ${devicesMinWidth.sm - 0.02}px)`.trimStart(),
    ...queries
  }
}

const tokens = {
  breakpoints,
  devicesMinWidth,
  responsiveMediaQuery: generateMediaQueries(),
  cssResponsiveMediaQuery: generateMediaQueries("@media"),
  desktopMediaQuery: `(min-width: ${mobileDevice.width}px) and (min-height: ${mobileDevice.height}px)`,
  mobileMediaQuery: `(max-width: ${mobileDevice.width - 0.2}px), (max-height: ${mobileDevice.height - 0.2}px)`,
  typography: {
    fontFamily: {
      title: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
      body: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    },
  },
  heading: {
    weight: {
      weak: 'lighter',
      regular: 'normal',
      strong: 'bolder',
    },
    level: {
      '1': 'xxlarge',
      '2': 'xlarge',
      '3': 'large',
      '4': 'standard',
      '5': 'small',
      '6': 'xsmall',
    }
  },
  text: {
    xxsmall: .625,
    xsmall: .75,
    small: .875,
    standard: 1,
    medium: 1.25,
    large: 1.5,
    xlarge: 2,
    xxlarge: 3.5,
  },
  textWeight: {
    weak: 'lighter',
    regular: 'normal',
    strong: 600,
    strongest: 900,
  },
  space: {
    medium: 2,
    gutter: 1,
    tiny: 0.125,
    xxxsmall:.25,
    xxsmall: .5,
    xsmall: .75,
    small: 1.5,
    large: 3,
    xlarge: 4,
    xxlarge: 5,
    none: 0,
  },
  transforms: {
    touchable: 'scale(1.03)',
  },
  transitions: {
    touchable: 'transform 200ms cubic-bezier(0.02, 1.505, 0.745, 1.235)',
  },
  border: {
    radius: {
      none: null, // @todo 2020-04-26 remove "none"
      xxsmall: 0.125,
      xsmall: 0.375,
      small: .5,
      medium:.75,
      standard: 1,
      large: 3,
    },
    width: {
      small: .0625,
      standard: .125,
      large: .25,
    },
    color: {
      standard: 'rgb(255 255 255 / .6)',
      focus: '#fff'
    },
  },
  shadows: {
    none: null,
    // @todo 2020-04-28 second shadow should be brandAccent instead of black
    small: '-.125rem -.125rem .375rem rgba(255,255,255,.3), .125rem .125rem .375rem rgba(0,0,0,.1)',
    standard: '-.625rem -.625rem 1.125rem rgba(255,255,255,.2), .625rem .625rem 1.125rem rgba(0,0,0,.05)',
    standardInset: 'inset -.25rem -.375rem .75rem rgba(255,255,255,.5), inset .25rem .375rem .75rem rgba(0,0,0,.1)',
    // medium: '',
    // small: '',
    // large: '',
    // outlineFocus: '',
  },
  // Default for Light theme
  color: {
    interfacePrimaryColor: '#fff',
    interfaceSecondaryColor: '#000',
    controlsPrimaryColor: '#fff',
    controlsSecondaryColor: '#000',
  },
};

export default tokens;
